






















































import Vue from 'vue'
import iconCheck from '@/assets/svg/rounded/check.svg?inline'
import iconChevronLeft from '@/assets/svg/rounded/chevron-left.svg?inline'
import { slider, slideritem } from 'vue-concise-slider'
import { IntegrationItemData, SliderOptions } from '@/models/integration'

interface Props {
  selectedItemData: IntegrationItemData
}

interface Data {
  activeImgIndex: number
  sliderOptions: SliderOptions
  openImg: boolean
}

interface Methods {
  slideNext: () => void
  slidePrev: () => void
  curentSlide: (data: SliderOptions) => void
  changeActiveImgIndex: (index: number) => void
}

interface Computed {
  isDisabledNext: boolean
  isDisabledPrev: boolean
  selectedIsImage: boolean
  selectedIsVideo: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    iconCheck,
    iconChevronLeft,
    slider,
    slideritem,
  },
  props: {
    selectedItemData: {
      required: true,
    },
  },
  data() {
    return {
      activeImgIndex: 0,
      sliderOptions: {
        pagination: false,
        thresholdTime: 300,
        speed: 300,
        loop: false,
        slidesToScroll: 1,
        currentPage: 0,
        infinite: 3,
        centeredSlides: false,
      },
      openImg: false,
    }
  },
  methods: {
    slideNext() {
      ;(this.$refs.slider as Vue).$emit('slideNext')
      if (!this.selectedIsImage && this.openImg) {
        this.openImg = false
      }
    },
    slidePrev() {
      ;(this.$refs.slider as Vue).$emit('slidePre')
      if (!this.selectedIsImage && this.openImg) {
        this.openImg = false
      }
    },
    changeActiveImgIndex(index) {
      this.activeImgIndex = index
    },
    curentSlide(data) {
      if (data.currentPage > this.selectedItemData.imgLinks.length) {
        this.activeImgIndex = 0
      }
      this.activeImgIndex = data.currentPage
    },
  },
  computed: {
    isDisabledNext() {
      return this.activeImgIndex === this.selectedItemData.imgLinks.length - 1
    },
    isDisabledPrev() {
      return this.activeImgIndex === 0
    },
    selectedIsImage() {
      return (
        this.selectedItemData.imgLinks[this.activeImgIndex].type === 'image'
      )
    },
    selectedIsVideo() {
      return (
        this.selectedItemData.imgLinks[this.activeImgIndex].type === 'video'
      )
    },
  },
})
